import { render, staticRenderFns } from "./CostTableInfoConfig.vue?vue&type=template&id=4d96549c&scoped=true&"
import script from "./CostTableInfoConfig.vue?vue&type=script&lang=js&"
export * from "./CostTableInfoConfig.vue?vue&type=script&lang=js&"
import style0 from "./CostTableInfoConfig.vue?vue&type=style&index=0&id=4d96549c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d96549c",
  null
  
)

export default component.exports